import * as ConstantRouter from '@/constant/router';
import * as ConstantLabel from '@/constant/label';

const route = {
  path: 'video-tutorials',
  name: ConstantRouter.VIDEO_TUTORIALS,
  component: () => import(/* webpackChunkName: "sources" */ '@/pages/video-tutorials/index.vue'),
  meta: {
    name: ConstantLabel.VIDEO_TUTORIALS,
    showUploadBox: true,
  },
};

export default route;
